import React from 'react';
import { Mail, Phone, Info } from 'lucide-react'; // Optional: lucide-react icons for visual appeal

const DataDeletionPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-gray-50 to-gray-100 p-6 md:p-12">
      <div className="max-w-3xl mx-auto bg-white shadow-xl rounded-2xl p-8 border border-gray-200">
        <h1 className="text-4xl font-bold text-blue-600 mb-4">Data Deletion Instructions</h1>
        <p className="text-gray-700 text-lg mb-6">
          We respect your privacy. If you wish to delete your data collected through our WhatsApp-based service, please follow the instructions below.
        </p>

        <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-lg mb-6">
          <div className="flex items-center gap-3">
            <Info className="text-blue-500" />
            <p className="text-blue-700 font-medium">
              Deletion requests will be processed within <strong>7 working days</strong>.
            </p>
          </div>
        </div>

        <ul className="space-y-4 text-gray-800 text-base">
          <li className="flex items-start gap-3">
            <Mail className="text-blue-500 mt-1" />
            Send an email to <strong>gatiiiyaan@gmail.com</strong> with the subject line: <em>"Data Deletion Request"</em>.
          </li>
          <li className="flex items-start gap-3">
            <Phone className="text-blue-500 mt-1" />
            Include your registered WhatsApp phone number in the message.
          </li>
          <li className="flex items-start gap-3">
            <Info className="text-blue-500 mt-1" />
            We’ll verify your identity and confirm data deletion via email.
          </li>
        </ul>

        <p className="mt-8 text-gray-600 text-sm text-center">
          Need help? Reach out to us anytime at <a href="mailto:gatiiiyaan@gmail.com" className="text-blue-600 underline">gatiiiyaan@gmail.com</a>.
        </p>
      </div>
    </div>
  );
};

export default DataDeletionPage;